import { InputLabel, MenuItem, Select } from '@mui/material'
import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import { PROJECT_STATUSES } from 'common/constants/projects'

import useRouter from 'hooks/useRouter'

import DropDownArrowIcon from './DropDownArrowIcon'

import styles from './ProjectStatusesFilter.module.scss'

export const FILTER_QUERY_PARAM_NAME = 'filter'
export const ALL_PROJECT_FILTER_ITEM = 'ALL'

function ProjectStatusesFilter({ selected, onChange }) {
    const { t } = useTranslation()
    const { queryParams, replaceQueryParam } = useRouter()
    const selectedValue = selected || ALL_PROJECT_FILTER_ITEM
    const isInitialized = useRef(false)

    useEffect(() => {
        if (!isInitialized.current) return

        replaceQueryParam(
            FILTER_QUERY_PARAM_NAME,
            selectedValue === ALL_PROJECT_FILTER_ITEM ? undefined : selectedValue,
        )
    }, [replaceQueryParam, selectedValue])

    useEffect(() => {
        if (isInitialized.current) return

        const param = queryParams[FILTER_QUERY_PARAM_NAME]
        if (param && PROJECT_STATUSES[param]) {
            onChange(param)
            isInitialized.current = true
            return
        }
        replaceQueryParam(FILTER_QUERY_PARAM_NAME, undefined)
        onChange(ALL_PROJECT_FILTER_ITEM)
        isInitialized.current = true
    }, [onChange, queryParams, replaceQueryParam])

    return (
        <div className={styles.filterRoot}>
            <InputLabel className={styles.label}>{t('Filter')}</InputLabel>
            <Select
                classes={{
                    select: styles.dropdown,
                }}
                variant="standard"
                value={selectedValue}
                autoWidth
                disableUnderline
                IconComponent={props => <DropDownArrowIcon props={props} />}
                onChange={evt => onChange(evt.target.value, evt)}
            >
                <MenuItem value={ALL_PROJECT_FILTER_ITEM}>{t('All')}</MenuItem>
                <MenuItem value={PROJECT_STATUSES.DRAFT}>{t('Drafts')}</MenuItem>
                <MenuItem value={PROJECT_STATUSES.PUBLISHED}>{t('Live ')}</MenuItem>
                <MenuItem value={PROJECT_STATUSES.TEMPLATE}>{t('Templates')}</MenuItem>
            </Select>
        </div>
    )
}

export default ProjectStatusesFilter
